export default __webpack_public_path__ + "static/media/web-push-off.06a1af18.svg";